<template>
<div class="chapter">
<div class="inner_page">
<nav epub:type="toc"><h2>Contents</h2>
<ol class="bbb-rw" epub:type="list"><li><a href="#/Text/cover">Cover</a></li>
<li><a href="#/Text/s001BookTitlePage01">Title Page</a></li>
<li><a href="#/Text/s003Copyright01">Copyright</a></li>
<li><a href="#/Text/s004Epigraph01">Epigraph</a></li>
<li><a href="#/Text/s005Acknowledgments01">Acknowledgments</a></li>
<li><a href="#/Text/s006Chapter001">Chapter 1</a></li>
<li><a href="#/Text/s007Chapter002">Chapter 2</a></li>
<li><a href="#/Text/s008Chapter003">Chapter 3</a></li>
<li><a href="#/Text/s009Chapter004">Chapter 4</a></li>
<li><a href="#/Text/s010Chapter005">Chapter 5</a></li>
<li><a href="#/Text/s011Chapter006">Chapter 6</a></li>
<li><a href="#/Text/s012Chapter007">Chapter 7</a></li>
<li><a href="#/Text/s013Chapter008">Chapter 8</a></li>
<li><a href="#/Text/s014Chapter009">Chapter 9</a></li>
<li><a href="#/Text/s015Chapter010">Chapter 10</a></li>
<li><a href="#/Text/s016Chapter011">Chapter 11</a></li>
<li><a href="#/Text/s017Chapter012">Chapter 12</a></li>
<li><a href="#/Text/s018Chapter013">Chapter 13</a></li>
<li><a href="#/Text/s019Chapter014">Chapter 14</a></li>
<li><a href="#/Text/s020Chapter015">Chapter 15</a></li>
<li><a href="#/Text/s021Chapter016">Chapter 16</a></li>
<li><a href="#/Text/s022Chapter017">Chapter 17</a></li>
<li><a href="#/Text/s023Chapter018">Chapter 18</a></li>
<li><a href="#/Text/s024Chapter019">Chapter 19</a></li>
<li><a href="#/Text/s025Chapter020">Chapter 20</a></li>
<li><a href="#/Text/s026Chapter021">Chapter 21</a></li>
<li><a href="#/Text/s027Chapter022">Chapter 22</a></li>
<li><a href="#/Text/s028Chapter023">Chapter 23</a></li>
<li><a href="#/Text/s029Chapter024">Chapter 24</a></li>
<li id="toc-discover-page"><a href="#/Text/discoverpage">Discover More</a></li>
<li><a href="#/Text/s030TeaserOpener01">An Excerpt from MAYBE THIS TIME</a></li>
<li><a href="#/Text/s033AboutTheAuthor01">About the Author</a></li>
<li><a href="#/Text/s034AdCard01">Also by Jennifer Snow</a></li>
<li><a href="#/Text/s035FrontSales01">Acclaim for Jennifer Snow’s Novels</a></li>
<li><a href="#/Text/s036BackAd01">Fall in Love with Forever Romance</a></li>
</ol></nav>
<nav class="ccc-rw" epub:type="landmarks"><h2>
    Navigation
   </h2>
<ol epub:type="list"><li>
<a epub:type="bodymatter" href="#/Text/s006Chapter001#Chapter1">
      Begin Reading
     </a>
</li>
<li>
<a epub:type="toc" href="#/Text/TOC">
      Table of Contents
     </a>
</li>
</ol></nav>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// TOC.vue?3b353941